import React, { Component, useState, useEffect } from "react";
import "../index.css";
import "./index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import { firebase } from "../../../firebase/config";
import "react-phone-number-input/style.css";
import ReactStars from "react-stars";
import { BiRightArrowAlt } from "react-icons/bi";
import { BsFillPersonPlusFill } from "react-icons/bs";
import { FaLock } from "react-icons/fa";
import { useAuth } from "../Context/AuthContext";
import mixpanel from "mixpanel-browser";
import { v4 as uuidv4 } from "uuid";
const HeadingMobile = ({ setIsOpen, profiles }) => {
  const [imageLoaded, setImageLoaded] = useState({});
  const { paid } = useAuth();

  const handleImageLoaded = (name) => {
    setImageLoaded((prev) => ({ ...prev, [name]: true }));
  };

  useEffect(() => {
    // Function to parse query parameters from window.location
    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      return {
        currency: params.get("currency"),
        price: params.get("price"),
      };
    };

    // Extract the currency and price query parameters
    const { currency, price } = getQueryParams();

    // If both currency and price exist, track the Purchase event with Facebook Pixel
    if (currency && price) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "purchase",
        value: price, // Replace 'price' with the transaction value
        currency: currency,
        content_id: "Credits",
        event_id: uuidv4(), // Replace 'currency' with the transaction currency code
      });
    }
  }, []);

  const placeholderStyle = {
    height: 110,
    width: 110,
    borderRadius: 100,
    backgroundColor: "grey",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const sortedProfiles = profiles.sort((a, b) =>
    b.free === a.free ? 0 : a.free ? -1 : 1
  );

  function getFirstName(fullName) {
    // Split the full name by space and return the first element of the array
    return fullName.split(" ")[0];
  }

  return (
    <MDBRow
      style={{
        color: "white",
        paddingTop: 130,
        width: "100vw",
        paddingLeft: 0,
        paddingBottom: "4vh",
      }}
    >
      <MDBCol className="d-flex justify-content-center" size="12">
        <div
          className="d-flex justify-content-center align-items-center" // Added align-items-center for vertical alignment
          style={{
            height: 30,
            width: "45vw",
            borderRadius: 200,
            backgroundColor: "#28262b",
            fontFamily: "CSSemiBold",
            fontSize: "3.4vw",
          }}
        >
          <img
            src={require("./TikTok.png")}
            style={{
              height: "4vw", // Adjust this to align with the text size
              marginRight: 6,
            }}
          />
          <p style={{ margin: 0 }}>As seen on TikTok</p>{" "}
          {/* Removed inline-block and added margin: 0 */}
        </div>
      </MDBCol>

      <MDBCol className="d-flex justify-content-center" size="12">
        <p
          style={{
            fontFamily: "CSBold",
            fontSize: "6vw",
            opacity: 1,
            lineHeight: 1.2,
            color: "rgb(242, 241, 243)",
            textAlign: "center",
            marginTop: 13,
          }}
        >
          Personalised AI videos from
          <br />
          your favorite stars
        </p>
      </MDBCol>
      <MDBCol
        className="d-flex justify-content-center align-items-center"
        size="12"
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Images */}
          <div style={{ display: "flex", marginRight: 10 }}>
            {[1, 2, 3, 4, 5].map((num) => (
              <img
                key={num}
                src={require(`./profile${num}.jpg`)}
                style={{
                  height: "5vw",
                  width: "5vw",
                  borderRadius: "50%", // 100 is not a valid value here
                  objectFit: "cover",
                  border: "2px solid white",
                  marginLeft: num === 1 ? 0 : -9, // Apply margin-left only for images after the first
                }}
              />
            ))}
          </div>

          {/* Text */}
          <p
            style={{
              fontFamily: "CSMedium",
              fontSize: "3.5vw",
              opacity: 0.7,
              lineHeight: 1.2,
              color: "rgb(242, 241, 243)",
              textAlign: "center",
              margin: "0px 5px 0px 0px", // Add horizontal margin
            }}
          >
            20,000+ videos already created
          </p>

          {/* Stars */}
          <div style={{ marginTop: 0 }}>
            <ReactStars
              color1={"#ffd700"}
              color2={"#ffd700"}
              count={5}
              value={5}
              edit={false}
              size={9}
              className="d-inline"
            />
          </div>
        </div>
      </MDBCol>
      <MDBCol className="d-flex justify-content-center" size="12">
        <MDBRow style={{ marginTop: 24, width: "90vw" }}>
          {sortedProfiles.slice(0, 6).map((profile) => (
            <MDBCol
              key={profile.name}
              className="d-flex justify-content-center"
              style={{ marginTop: 0 }}
              size="4"
            >
              <NavLink
                onClick={() => {
                  mixpanel.track("Landing page profile clicked", {
                    profile: profile.name,
                  });
                }}
                exact
                to={
                  profile.free || paid
                    ? `/request?id=${profile.profileID}`
                    : "/checkout"
                }
              >
                <div style={{ position: "relative", display: "inline-block" }}>
                  {" "}
                  {/* Flex container for image and icon */}
                  {!imageLoaded[profile.name] && (
                    <div style={placeholderStyle}></div>
                  )}
                  <img
                    src={profile.image}
                    onLoad={() => handleImageLoaded(profile.name)}
                    style={{
                      height: "26vw",
                      width: "26vw",
                      borderRadius: 100,
                      objectFit: "cover",
                      display: imageLoaded[profile.name] ? "block" : "none",
                      border: "2px solid white",
                      opacity: profile.free === true || paid ? 1 : 0.3,
                      filter:
                        profile.free === true || paid ? null : "blur(2px)",
                    }}
                  />
                  {profile.free !== true && !paid && (
                    <FaLock
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: 30,
                      }}
                    />
                  )}
                </div>

                <p
                  style={{
                    textAlign: "center",
                    marginTop: 10,
                    fontFamily: "CSSemiBold",
                    fontSize: "3.9vw",
                  }}
                >
                  {getFirstName(profile.name)}
                </p>
              </NavLink>
            </MDBCol>
          ))}
        </MDBRow>
      </MDBCol>

      <MDBCol size="12" className="d-flex justify-content-center">
        <NavLink
          to="/explore"
          onClick={() => mixpanel.track("Clicked explore on Landing Page")}
          exact
          style={{
            height: 54,
            width: "85vw",
            marginTop: 10,
            border: "2px solid rgb(128, 54, 224)",
            borderRadius: 100,
            backgroundColor: "rgb(128, 54, 224)",
            display: "flex", // Flex container
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          }}
        >
          <p
            style={{
              fontFamily: "CSMedium",
              fontSize: 16,
              color: "white",
              margin: 0, // Remove any margin
              zIndex: 300,
            }}
          >
            Explore all celebrities{" "}
            <BiRightArrowAlt style={{ fontSize: 18 }} className="d-inline" />
          </p>
        </NavLink>
      </MDBCol>
    </MDBRow>
  );
};

export default withRouter(HeadingMobile);
